import m from "../../es2015/lang/en";
window.am4lang_en = m;


//////////////////
// WEBPACK FOOTER
// ./lang/en.js
// module id = ni0V
// module chunks = 39d1